export const employeeProfileSteps = ()=>{ 
  return[
  {
    target: '[data-tour="profile-card"]',
    title: "👤 Your Profile",
    content: "This is your profile card with all your details.",
    disableBeacon: true,
  },
  {
    target: '[data-tour="profile-clockin-btn"]',
    title: "⏰ Clock In / Out",
    content: "Use this button to clock in and out of work.",
    disableBeacon: true,
  },
    {
    target: '[data-tour="employee-profile-tabs"]',
    title: "📑 Profile Tabs",
    content: ( <div>
      <p><strong>📋 Personal-Details:</strong> View your personal details.</p>
      <p><strong>💼 Work:</strong> View your work details and assignments.</p>
      <p><strong>👥 Team:</strong> See your team members.</p>
      <p><strong>📊 Report:</strong> View your reporting manager.</p>
      <p><strong>🎓 Education:</strong> View and update your education details.</p>
      <p><strong>👨‍👩‍👧 Family:</strong> View and update your family details.</p>
      <p><strong>📄 Documents:</strong> Upload and manage your documents.</p>
      <p><strong>📅 Workweek:</strong> View your assigned workweek schedule.</p>
      <p><strong>🚪 Offboarding:</strong> Manage your offboarding process.</p>
    </div>),
    disableBeacon: true,
  }
];
}


